












































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
  import { Validations } from 'vuelidate-property-decorators';
  import { required, requiredIf, email, minLength } from 'vuelidate/lib/validators';
  import MaskedInput from 'vue-masked-input';
  import Navigator from '../Study/Navigator.vue';
  import {
    countries,
    states,
    provinces,
    germanyStates,
    israelDistricts,
    austrailiaStates,
    providers,
    zones,
    degrees,
  } from '../../shared/constants';
  import { bus, store, client, getUserInfo } from '../../shared';
  import { UserInfo } from '../../shared/user';
  import _ from 'lodash';
  import { ToggleButton } from 'vue-js-toggle-button';
  @Component({
    components: {
      MaskedInput,
      ToggleButton,
    },
  })
  export default class ContactInfo extends Vue {
    /* ------------- Data -------------------- */
    $v: any;
    states: any = states;
    provinces: any = provinces;
    germanyStates: any = germanyStates;
    israelDistricts: any = israelDistricts;
    australiaStates: any = austrailiaStates;
    countries: any = countries;
    originalPrimarySelected: any;
    originalSecondarySelected: any;
    isEUCountry: boolean = false;
    orcSelection?: boolean;
    activeSession: any = {};
    providers: any = providers;
    degrees: any = degrees;
    degreeOtherSelected: boolean = false;
    degreeOther: any;
    zones: any = zones;
    editMode?: any = false;
    addingMode?: any = false;
    isShow: boolean = false;
    hasPrimary: boolean = false;
    hasValidORCID: boolean = false;
    form: any = {
      urn: '',
      firstName: '',
      lastName: '',
      middleInitial: null,
      institution: '',
      title: null,
      pI_Phone: null,
      pI_Phone_Ext: null,
      pI_Email: '',
      textMsg: false,
      pI_Cell: null,
      provider_ID: null,
      pI_Address_1: null,
      pI_Address_2: null,
      pI_City: null,
      pI_State: null,
      pI_State_Oth: null,
      pI_Province: null,
      time_Zone: null,
      timeZoneOther: null,
      country: null,
      pI_Zip: null,
      hasORCID: false,
      rsnNoORCID: null,
      orcid: null,
      // pi_contact: [],
      degrees: [],
      degreeOther: null,
      personId: '',
      wKShipment: false,
      // shippingNote: null,
      // exp_Ship: null,
      // exp_Ship_Acct: null,
      // exp_Ship_2: null,
      // exp_Ship_Acct_2: null,
      // eori: null,
      shipCountry: null,
      ship_Addr_1: null,
      ship_Addr_2: null,
      ship_City: null,
      ship_State: null,
      ship_Province: null,
      ship_State_Oth: null,
      ship_Zip: null,
      wK_Contact: null,
      wkShipCountry: null,
      wK_Ship_Addr_1: null,
      wK_Ship_Addr_2: null,
      wK_Ship_City: null,
      wK_Ship_State: null,
      wK_Ship_Province: null,
      wK_Ship_State_Oth: null,
      wK_Ship_Zip: null,
      wK_Phone: null,
      sameasMailing: false,
      wksameasMailing: false,
    };
    investigatorDegrees: [] = [];
    // selected: [];
    @Validations()
    validations: any = {
      form: {
        urn: {},
        firstName: {
           required,
           minLength: minLength(2),
        },
        lastName: {
             required,
             minLength: minLength(2),
            },
         middleInitial: {},
        institution: {
            required,
            minLength: minLength(2),
            },
        title: {
          required,
          minLength: minLength(2),
        },
        pI_Phone: {
          required,
            phoneValid: (value: any, vm: any, form: any) => {
            if (
              value !== undefined &&
              value !== null &&
              value.indexOf('_') === -1
            ) {
              return true;
            }
            return false;
          },
          usPhoneValid: (value: any, vm: any) => {
            const validationRegex = /^\([2-9]{1}\d{2}\)[0-9]{3}-[0-9]{4}$/;
            const internationalValidationRegex = /^[ ]*(?:\+?(\d{1,5}))*[-. )]?(\d+)?[-. (]?([2-9]\d{2})*[-. )]*?(\d{2})*[-. )]*(\d{3,4})*[-. ]*(\d{4,20})[ ]*$/;
            if (
              this.form.country !== '' &&
              (this.form.country === 'United States' ||
                this.form.country === 'Canada') &&
              value !== null &&
              value.match(validationRegex)
            ) {
              return true;
            }
            if (
              this.form.country !== '' &&
              this.form.country !== 'United States' &&
              this.form.country !== 'Canada' &&
              value !== null &&
              value.match(internationalValidationRegex)
            ) {
              return true;
            }
            return false;
          },
        },
        pI_Phone_Ext: {},
        pI_Email: {
          required,
          email,
        },
        textMsg: { required },
        pI_Cell: {
          requiredIf: requiredIf((form: any) => form.textMsg === true),
          phoneValid: (value: any, vm: any, form: any) => {
            if (
              value !== undefined &&
              value !== null &&
              value.indexOf('_') === -1
            ) {
              return true;
            }
            if (this.form.textMsg === false) {
              return true;
            }
            return false;
          },
          usPhoneValid: (value: any, vm: any) => {
            const validationRegex = /^\([2-9][0-9]{2}\)[0-9]{3}-[0-9]{4}$/;
            const internationalValidationRegex = /^[ ]*(?:\+?(\d{1,5}))*[-. )]?(\d+)?[-. (]?([2-9]\d{2})*[-. )]*?(\d{2})*[-. )]*(\d{3,4})*[-. ]*(\d{4,20})[ ]*$/;
            if (
              this.form.country !== '' &&
              (this.form.country === 'United States' ||
                this.form.country === 'Canada') &&
              this.form.textMsg &&
              value !== null &&
              value.match(validationRegex)
            ) {
              return true;
            }
            if (
              this.form.country !== '' &&
              this.form.country !== 'United States' &&
              this.form.country !== 'Canada' &&
              this.form.textMsg &&
              value !== null &&
              value.match(internationalValidationRegex)
            ) {
              return true;
            }
            return false;
          },
        },
        provider_ID: {
          requiredIf: requiredIf(
            (form: any) => this.form.textMsg || this.form.pI_Cell! == null,
          ),
        },
       pI_Address_1: {
                required,
                minLength: minLength(2),
            },
        pI_Address_2: {},
            pI_City: {
                required,
                minLength: minLength(2),
},
        country: { required },
        pI_State: {
          requiredIf: requiredIf(
            (form: any) =>
              form.country !== '' && form.country === 'United States',
          ),
        },
        pI_State_Oth: {
          requiredIf: requiredIf(
            (form: any) =>
              form.country !== '' &&
              form.country !== 'United States' &&
              form.country !== 'Canada' &&
              (form.country === 'Germany' ||
                form.country === 'Australia' ||
                form.country === 'Israel'),
          ),
        },
        pI_Province: {
          requiredIf: requiredIf(
            (form: any) =>
              form.country !== '' &&
              form.country !== 'United States' &&
              form.country === 'Canada',
          ),
        },
        time_Zone: {
          requiredIf: requiredIf((form: any) => this.form.time_Zone < '1'),
        },
        timeZoneOther: {
            requiredIf: requiredIf((form: any) => this.form.time_Zone === '-9'),
            minLength: minLength(2),
        },
        pI_Zip: {
           required,
           minLength: minLength(2),
        },
        hasORCID: { required },
        rsnNoORCID: {
            requiredIf: requiredIf((form: any) => form.hasORCID === false),
            minLength: minLength(2),
        },
        orcid: {
          requiredIf: requiredIf((form: any) => form.hasORCID === true),
          orcValid: (value: any, vm: any, form: any) => {
            const result = false;
            const segments = _.split(value, '-');
            if (segments.length > 0 && this.form.hasORCID) {
              if (
                !_.isNaN(parseFloat(segments[0])) &&
                segments[0] >= 0.0 &&
                !_.isNaN(parseFloat(segments[1])) &&
                segments[1] >= 0.0 &&
                !_.isNaN(parseFloat(segments[2])) &&
                segments[2] >= 0.0 &&
                !_.isNaN(
                  parseFloat(segments[3].substring(0, 2)) &&
                    segments[3].substring(0, 2) > 0.0,
                ) &&
                segments[3].substring(2, 4).indexOf('_') === -1
              ) {
                this.hasValidORCID = true;
                return true;
              } else {
                this.hasValidORCID = false;
                return false;
              }
            }
            if (
              this.form.hasORCID === false &&
              this.form.rsnNoORCID !== null &&
              this.form.rsnNoORCID.length < 1
            ) {
              this.hasValidORCID = false;
              return true;
            } else {
              return false;
            }
          },
        },
        wKShipment: { required },
        // exp_Ship_Acct: { required },
        // exp_Ship: { required },
        // exp_Ship_2: {
        //  requiredIf: requiredIf(
        //    (form: any) =>
        //      form.exp_Ship_Acct_2 !== '' && form.exp_Ship_Acct_2 !== null,
        //  ),
        // },
        // exp_Ship_Acct_2: {
        //  requiredIf: requiredIf(
        //    (form: any) => form.exp_Ship_2 === '1' || form.exp_Ship_2 === '2',
        //  ),
        // },
        // eori: { required },
        // shippingNote: {},
        shipCountry: { required },
        ship_Addr_1: {
              required,
              minLength: minLength(2),
         },
        ship_Addr_2: {},
        ship_City: {
            required,
            minLength: minLength(2),
       },
        ship_State: {
          requiredIf: requiredIf(
            (form: any) =>
              form.shipCountry !== '' &&
              form.shipCountry === 'United States' &&
              form.shipCountry !== 'Canada',
          ),
        },
        ship_Province: {
          requiredIf: requiredIf(
            (form: any) =>
              form.shipCountry !== 'United States' &&
              form.shipCountry === 'Canada' &&
              (form.shipCountry !== 'Germany' ||
                form.shipCountry !== 'Australia' ||
                form.shipCountry !== 'Israel'),
          ),
        },
        ship_State_Oth: {
          requiredIf: requiredIf(
            (form: any) =>
              form.shipCountry !== '' &&
              form.shipCountry !== 'United States' &&
              form.shipCountry !== 'Canada' &&
              (form.shipCountry === 'Germany' ||
                form.shipCountry === 'Australia' ||
                form.shipCountry === 'Israel'),
          ),
        },
            ship_Zip: {
                required,
                minLength: minLength(2),
},
        wK_Contact: {},
        wkShipCountry: {
          requiredIf: requiredIf((form: any) => form.wKShipment === true),
        },
        wK_Ship_Addr_1: {
            requiredIf: requiredIf((form: any) => form.wKShipment === true),
            minLength: minLength(2),
        },
        wK_Ship_Addr_2: {},
        wK_Ship_City: {
            requiredIf: requiredIf((form: any) => form.wKShipment === true),
            minLength: minLength(2),
        },
        wK_Ship_State: {
          requiredIf: requiredIf(
            (form: any) =>
              form.wKShipment === true &&
              form.wkShipCountry !== '' &&
              form.wkShipCountry === 'United States' &&
              form.wkShipCountry !== 'Canada',
          ),
        },
        wK_Ship_State_Oth: {
          requiredIf: requiredIf(
            (form: any) =>
              form.wKShipment === true &&
              form.wkShipCountry !== '' &&
              form.wkShipCountry !== 'United States' &&
              form.wkShipCountry !== 'Canada' &&
              (form.wkShipCountry === 'Germany' ||
                form.wkShipCountry === 'Australia' ||
                form.wkShipCountry === 'Israel'),
          ),
        },
        wK_Ship_Province: {
          requiredIf: requiredIf(
            (form: any) =>
              form.wKShipment === true &&
              form.wkShipCountry !== '' &&
              form.wkShipCountry !== 'United States' &&
              form.wkShipCountry === 'Canada',
          ),
        },
        wK_Ship_Zip: {
            requiredIf: requiredIf((form: any) => form.wKShipment === true),
            minLength: minLength(2),
        },
        wK_Phone: {
          phoneValid: (value: any, vm: any) => {
            const validationRegex = /^[ ]*(?:\+?(\d{1,5}))*[-. )]?(\d+)?[-. (]?([2-9]\d{2})*[-. )]*?(\d{2})*[-. )]*(\d{3,4})*[-. ]*(\d{4,20})[ ]*$/;
            if (
              value !== undefined &&
              value !== null &&
              value.indexOf('_') === -1 &&
              value.match(validationRegex)
            ) {
              return true;
            }
            if (value === undefined || value === '' || value === null) {
              return true;
            }
            if (
              value !== null &&
              value.length > 0 &&
              !value.match(validationRegex)
            ) {
              return false;
            }
            return false;
          },
        },
        sameasMailing: {},
        wksameasMailing: {},
        degrees: { required },
        degreeOther: {
          requiredIf: requiredIf(
            (form: any) => this.form.degrees.indexOf(-9) !== -1,
            ),
            minLength: minLength(2),
        },
      },
    };
    @Watch('form.pI_Cell')
    onCellPhoneChanged(value: any) {
      if (value === '') {
        this.form.pI_Cell = null;
        }
      //  this.$v.form.pI_Cell.$touch();
    }
    @Watch('form.middleInitial')
      onMiddleInitialChanged(value: any) {
      if (value === '') {
        this.form.middleInitial = null;
      }
    }
    @Watch('pi_contact.textMsg')
    onContactTextMsgChanged(newValue: boolean, oldValue: boolean) {
      if (newValue === false) {
        this.form.pI_Cell = null;
        this.form.provider_ID = null;
      }
    }
    @Watch('form.textMsg')
    ontextMsgChanged(newValue: boolean, oldValue: boolean) {
      if (newValue === false) {
        this.form.pI_Cell = null;
        this.form.provider_ID = null;
      }
    }
    @Watch('form.pI_Phone')
    onPhoneChanged(value: any) {
      if (value === '') {
        this.form.pI_Phone = null;
      }
      this.submit();
      this.$v.form.pI_Phone.$touch();
    }
    @Watch('form.pI_Address_1')
    onpI_Address_1Changed(value: any) {
      if (value === '') {
        this.form.pI_Address_1 = null;
      }
    }
    @Watch('form.pI_Address_2')
    onpI_Address_2Changed(value: any) {
      if (value === '') {
        this.form.pI_Address_2 = null;
      }
    }
    @Watch('form.pI_City')
    onPI_CityChanged(value: any) {
      if (value === '') {
        this.form.pI_City = null;
      }
    }
    @Watch('form.pI_Zip')
    onPI_ZipChanged(value: any) {
      if (value === '') {
        this.form.pI_Zip = null;
      }
    }
    @Watch('form.pI_Phone_Ext')
    onpI_Phone_ExtChanged(value: any) {
      if (value === '') {
        this.form.pI_Phone_Ext = null;
      }
    }
    @Watch('form.orcid')
    onORCIDChanged(value: any) {
      this.submit();
      this.$v.form.orcid.$touch();
    }
    @Watch('form.hasORCID')
    public onHasORCIDChanged(newValue: boolean, oldValue: boolean) {
      if (newValue === true) {
        this.form.rsnNoORCID = null;
      } else {
        this.form.orcid = null;
      }
      this.submit();
    }
    @Watch('form.country')
    public onCountryChanged(newValue: string, oldValue: string) {
      if (newValue === 'United States') {
        this.form.pI_Province = null;
        this.form.pI_State_Oth = null;
      } else {
        if (newValue === 'Canada') {
          this.form.pI_State = null;
          this.form.pI_State_Oth = null;
        } else {
          if (newValue !== 'United States' && newValue !== 'Canada') {
            this.form.pI_State = null;
            this.form.pI_Province = null;
          }
        }
      }
      this.submit();
    }
    @Watch('form.shipCountry')
    public onShipCountryChanged(newValue: string, oldValue: string) {
      if (newValue === 'United States') {
        this.form.ship_State_Oth = null;
        this.form.ship_Province = null;
      } else {
        if (newValue === 'Canada') {
          this.form.ship_State = null;
          this.form.ship_State_Oth = null;
        } else {
          if (newValue !== 'United States' && newValue !== 'Canada') {
            this.form.ship_State = null;
            this.form.ship_Province = null;
          }
        }
      }
      this.submit();
    }
    @Watch('form.wkShipCountry')
    public onwkShipCountryChanged(newValue: string, oldValue: string) {
      if (newValue === 'United States') {
        this.form.wK_Ship_State_Oth = null;
        this.form.wK_Ship_Province = null;
      } else {
        if (newValue === 'Canada') {
          this.form.wK_Ship_State = null;
          this.form.wK_Ship_State_Oth = null;
        } else {
          if (newValue !== 'United States' && newValue !== 'Canada') {
            this.form.wK_Ship_State = null;
            this.form.wK_Ship_Province = null;
          }
        }
      }
      this.submit();
    }
    @Watch('form.wKShipment')
    onwKShipmentChanged(value: any) {
      if (!value) {
        this.form.wK_Ship_Addr_1 = null;
        this.form.wK_Ship_Addr_2 = null;
        this.form.wK_Ship_City = null;
        this.form.wK_Ship_State = null;
        this.form.wK_Ship_Province = null;
        this.form.wK_Ship_State_Oth = null;
        this.form.wK_Ship_Zip = null;
        this.form.wK_Phone = null;
        this.form.wkShipCountry = null;
        this.form.wksameasMailing = null;
      }
      this.submit();
      this.$v.form.wKShipment.$touch();
    }
    @Watch('form.wksameasMailing')
    onWKSameAsShipmentChanged(value: any) {
      this.submit();
      this.$v.form.wksameasMailing.$touch();
    }
    @Watch('form.sameasMailing')
    onSameAsShipmentChanged(value: any) {
      this.submit();
      this.$v.form.wksameasMailing.$touch();
    }
    @Watch('form.wK_Phone')
    onWKPhoneChanged(value: any) {
      this.submit();
      this.$v.form.wK_Phone.$touch();
    }
    @Watch('form.shippingNote')
    onShippingNoteChanged(value: any) {
      if (value === '') {
        this.form.shippingNote = null;
      }
    }
    @Watch('form.ship_Addr_1')
    onShip_Address_1Changed(value: any) {
      if (value === '') {
        this.form.ship_Addr_1 = null;
      }
    }
    @Watch('form.ship_Addr_2')
    onShip_Address_2Changed(value: any) {
      if (value === '') {
        this.form.ship_Addr_2 = null;
      }
    }
    @Watch('form.ship_City')
    onShip_CityChanged(value: any) {
      if (value === '') {
        this.form.ship_City = null;
      }
    }
    @Watch('form.ship_Zip')
    onShip_ZipChanged(value: any) {
      if (value === '') {
        this.form.ship_Zip = null;
      }
    }
    @Watch('form.wK_Ship_Addr_1')
    onWKShip_Address_1Changed(value: any) {
      if (value === '') {
        this.form.wK_Ship_Addr_1 = null;
      }
    }
    @Watch('form.wK_Ship_Addr_2')
    onWKShip_Address_2Changed(value: any) {
      if (value === '') {
        this.form.wK_Ship_Addr_2 = null;
      }
    }
    @Watch('form.wK_Ship_City')
    onSWKhip_CityChanged(value: any) {
      if (value === '') {
        this.form.wK_Ship_City = null;
      }
    }
    @Watch('form.wK_Ship_Zip')
    onWKShip_ZipChanged(value: any) {
      if (value === '') {
        this.form.wK_Ship_Zip = null;
      }
    }
    @Watch('form.wK_Phone')
    onwK_PhoneChanged(value: any) {
      if (value === '') {
        this.form.wK_Phone = null;
      }
    }
    @Watch('form.wK_Contact')
    onwK_ContactChanged(value: any) {
      if (value === '') {
        this.form.wK_Contact = null;
      }
    }
    @Watch('userInfo.study.form', { deep: true })
    public formUpdated(newValue: any, oldValue: any) {
      setTimeout(() => {
        if (newValue !== oldValue && this.userInfo.study.form !== undefined) {
          // Research Info
          if (this.userInfo.study.form.study_Title !== null) {
            this.form.study_Title = this.userInfo.study.form.study_Title;
          }
          if (this.userInfo.study.form.projAbstract !== null) {
            this.form.projAbstract = this.userInfo.study.form.projAbstract;
          }
          if (this.userInfo.study.form.researchMethods !== null) {
            this.form.researchMethods = this.userInfo.study.form.researchMethods;
          }
          if (this.userInfo.study.form.isletsReqReason !== null) {
            this.form.isletsReqReason = this.userInfo.study.form.isletsReqReason;
          }
          if (this.userInfo.study.form.rationaleFrozen !== null) {
            this.form.rationaleFrozen = this.userInfo.study.form.rationaleFrozen;
          }
          if (this.userInfo.study.form.rationaleHistoSlides !== null) {
            this.form.rationaleHistoSlides = this.userInfo.study.form.rationaleHistoSlides;
          }
          if (this.userInfo.study.form.rationaleAcinar !== null) {
            this.form.rationaleAcinar = this.userInfo.study.form.rationaleAcinar;
          }
          if (this.userInfo.study.form.animalResearch !== null) {
            this.form.animalResearch = this.userInfo.study.form.animalResearch;
          }
          if (this.userInfo.study.form.iacuC_Status !== null) {
            this.form.iacuC_Status = this.userInfo.study.form.iacuC_Status;
          }
          if (this.userInfo.study.form.iacuC_App_No !== null) {
            this.form.iacuC_App_No = this.userInfo.study.form.iacuC_App_No;
          }
          if (this.userInfo.study.form.iacuC_App_Dt !== null) {
            this.form.iacuC_App_Dt = this.userInfo.study.form.iacuC_App_Dt;
          }
          if (this.userInfo.study.form.iacuC_App_Dt !== null) {
            this.form.iacuC_App_Dt = this.userInfo.study.form.iacuC_App_Dt;
          }
          if (this.userInfo.study.form.cellStimulus !== null) {
            this.form.cellStimulus = this.userInfo.study.form.cellStimulus;
          }
          if (this.userInfo.study.form.cellDeath !== null) {
            this.form.cellDeath = this.userInfo.study.form.cellDeath;
          }
          if (this.userInfo.study.form.type1Diabetes !== null) {
            this.form.type1Diabetes = this.userInfo.study.form.type1Diabetes;
          }
          if (this.userInfo.study.form.alphaCells !== null) {
            this.form.alphaCells = this.userInfo.study.form.alphaCells;
          }
          if (this.userInfo.study.form.geneticsGenomics !== null) {
            this.form.geneticsGenomics = this.userInfo.study.form.geneticsGenomics;
          }
          if (this.userInfo.study.form.otherArea !== null) {
            this.form.otherArea = this.userInfo.study.form.otherArea;
          }
          if (this.userInfo.study.form.otherAreaText !== null) {
            this.form.otherAreaText = this.userInfo.study.form.otherAreaText;
          }
          // Study Interest
          if (this.userInfo.study.form.culturedIslets !== null) {
            this.form.culturedIslets = this.userInfo.study.form.culturedIslets;
          }
          if (this.userInfo.study.form.frozenIslets !== null) {
            this.form.frozenIslets = this.userInfo.study.form.frozenIslets;
          }
          if (this.userInfo.study.form.acinar !== null) {
            this.form.acinar = this.userInfo.study.form.acinar;
          }
          if (this.userInfo.study.form.histoSlides !== null) {
            this.form.histoSlides = this.userInfo.study.form.histoSlides;
          }
          if (this.userInfo.study.form.ancillary !== null) {
            this.form.ancillary = this.userInfo.study.form.ancillary;
          }
          if (this.userInfo.study.form.bloodProd !== null) {
            this.form.bloodProd = this.userInfo.study.form.bloodProd;
          }
          if (this.userInfo.study.form.serum !== null) {
            this.form.serum = this.userInfo.study.form.serum;
          }
          if (this.userInfo.study.form.plasma !== null) {
            this.form.plasma = this.userInfo.study.form.plasma;
          }
          if (this.userInfo.study.form.ductal !== null) {
            this.form.ductal = this.userInfo.study.form.ductal;
          }
          if (this.userInfo.study.form.frozenPancreaticPcs !== null) {
            this.form.frozenPancreaticPcs = this.userInfo.study.form.frozenPancreaticPcs;
          }
          if (this.userInfo.study.form.lymphNode !== null) {
            this.form.lymphNode = this.userInfo.study.form.lymphNode;
          }
          if (this.userInfo.study.form.spleen !== null) {
            this.form.spleen = this.userInfo.study.form.spleen;
          }
          if (this.userInfo.study.form.duodenum !== null) {
            this.form.duodenum = this.userInfo.study.form.duodenum;
          }
          // Islet Requirements
          if (this.userInfo.study.form.comp_Dt !== null) {
            this.form.comp_Dt = this.userInfo.study.form.comp_Dt;
          }
          if (this.userInfo.study.form.ieQs_Ideal !== null) {
            this.form.ieQs_Ideal = this.userInfo.study.form.ieQs_Ideal;
          }
          if (this.userInfo.study.form.ieQs_Min !== null) {
            this.form.ieQs_Min = this.userInfo.study.form.ieQs_Min;
          }
          if (this.userInfo.study.form.purity_Ideal !== null) {
            this.form.purity_Ideal = this.userInfo.study.form.purity_Ideal;
          }
          if (this.userInfo.study.form.purity_Min !== null) {
            this.form.purity_Min = this.userInfo.study.form.purity_Min;
          }
          if (this.userInfo.study.form.viability_Min !== null) {
            this.form.viability_Min = this.userInfo.study.form.viability_Min;
          }
          if (this.userInfo.study.form.viability_Ideal !== null) {
            this.form.viability_Ideal = this.userInfo.study.form.viability_Ideal;
          }
          if (this.userInfo.study.form.freq_Ideal !== null) {
            this.form.freq_Ideal = this.userInfo.study.form.freq_Ideal;
          }
          if (this.userInfo.study.form.freq_Min !== null) {
            this.form.freq_Min = this.userInfo.study.form.freq_Min;
          }
          if (this.userInfo.study.form.tot_IEQs_Needed !== null) {
            this.form.tot_IEQs_Needed = this.userInfo.study.form.tot_IEQs_Needed;
          }
          if (this.userInfo.study.form.viability_Min !== null) {
            this.form.viability_Min = this.userInfo.study.form.viability_Min;
          }
          if (this.userInfo.study.form.cultured_Ideal !== null) {
            this.form.cultured_Ideal = this.userInfo.study.form.cultured_Ideal;
          }
          if (this.userInfo.study.form.cultured_Min !== null) {
            this.form.cultured_Min = this.userInfo.study.form.cultured_Min;
          }
          if (this.userInfo.study.form.diabetic_Ideal !== null) {
            this.form.diabetic_Ideal = this.userInfo.study.form.diabetic_Ideal;
          }
          if (this.userInfo.study.form.diabetic_Min !== null) {
            this.form.diabetic_Min = this.userInfo.study.form.diabetic_Min;
          }
          if (this.userInfo.study.form.cultureLen !== null) {
            this.form.cultureLen = this.userInfo.study.form.cultureLen;
          }
          if (this.userInfo.study.form.cultured_Min !== null) {
            this.form.cultured_Min = this.userInfo.study.form.cultured_Min;
          }
          if (this.userInfo.study.form.cultureMinDay !== null) {
            this.form.cultureMinDay = this.userInfo.study.form.cultureMinDay;
          }
          if (this.userInfo.study.form.cultureMinHr !== null) {
            this.form.cultureMinHr = this.userInfo.study.form.cultureMinHr;
          }
          if (this.userInfo.study.form.cultured_Min !== null) {
            this.form.cultured_Min = this.userInfo.study.form.cultured_Min;
          }
          if (this.userInfo.study.form.cultureMaxDay !== null) {
            this.form.cultureMaxDay = this.userInfo.study.form.cultureMaxDay;
          }
          if (this.userInfo.study.form.cultureMaxHr !== null) {
            this.form.cultureMaxHr = this.userInfo.study.form.cultureMaxHr;
          }
          // Funding Info
          if (this.userInfo.study.form.pilot !== null) {
            this.form.pilot = this.userInfo.study.form.pilot;
          }
          if (this.userInfo.study.form.peer_Rev_Grant !== null) {
            this.form.peer_Rev_Grant = this.userInfo.study.form.peer_Rev_Grant;
          }
          if (this.userInfo.study.form.fundsAva !== null) {
            this.form.fundsAva = this.userInfo.study.form.fundsAva;
          }
          if (this.userInfo.study.form.non_Profit !== null) {
            this.form.non_Profit = this.userInfo.study.form.non_Profit;
          }
        }
      }, 1000);
    }
    get contactList() {
      return this.userInfo.study.piContacts;
    }
    get existingContactList() {
      return this.userInfo.study.piExistingContacts;
    }
    get userInfo() {
      return store.userInfo;
    }
    validateForm() {
      return this.$v.$invalid;
    }
    get phoneMasked() {
      if (
        this.form.country === 'United States' ||
        this.form.country === 'Canada'
      ) {
        return true;
      }
      return false;
    }
    submit() {
      // this.$v.$touch();  Removed so form wouldn't be validated on load
        this.$emit('update', {
        formData: this.form,
        id: 1,
        isValid: !this.$v.$invalid,
      });
    }
    activated() {
      if (
        this.userInfo.study !== undefined &&
        this.userInfo.study.form !== undefined
      ) {
        Object.assign(this.form, this.userInfo.study.form);
      }
    }
    copyMailing() {
      if (this.form.sameasMailing) {
        this.form.shipCountry = this.form.country;
        this.form.ship_Addr_1 = this.form.pI_Address_1;
        this.form.ship_Addr_2 = this.form.pI_Address_2;
        this.form.ship_City = this.form.pI_City;
        this.form.ship_State = this.form.pI_State;
        this.form.ship_Province = this.form.pI_Province;
        this.form.ship_State_Oth = this.form.pI_State_Oth;
        this.form.ship_Zip = this.form.pI_Zip;
      } else {
        this.form.shipCountry = null;
        this.form.ship_Addr_1 = null;
        this.form.ship_Addr_2 = null;
        this.form.ship_City = null;
        this.form.ship_State = null;
        this.form.ship_State_Oth = null;
        this.form.ship_Province = null;
        this.form.ship_Zip = null;
      }
    }
    copyMailingToWeekend() {
      if (this.form.wksameasMailing) {
        this.form.wkShipCountry = this.form.country;
        this.form.wK_Ship_Addr_1 = this.form.pI_Address_1;
        this.form.wK_Ship_Addr_2 = this.form.pI_Address_2;
        this.form.wK_Ship_City = this.form.pI_City;
        this.form.wK_Ship_State = this.form.pI_State;
        this.form.wK_Ship_Province = this.form.pI_Province;
        this.form.wK_Ship_State_Oth = this.form.pI_State_Oth;
        this.form.wK_Ship_Zip = this.form.pI_Zip;
      } else {
        this.form.wkShipCountry = null;
        this.form.wK_Ship_Addr_1 = null;
        this.form.wK_Ship_Addr_2 = null;
        this.form.wK_Ship_City = null;
        this.form.wK_Ship_State = null;
        this.form.wK_Ship_State_Oth = null;
        this.form.wK_Ship_Province = null;
        this.form.wK_Ship_Zip = null;
      }
    }
    created() {
      bus.$on('userInfo', (info: any) => {
        if (this.form.firstName === '') {
          this.form.firstName = info.userInfo.firstName;
        }
        if (this.form.lastName === '') {
          this.form.lastName = info.userInfo.lastName;
        }
        if (this.form.institution === '') {
          this.form.institution = info.userInfo.institution;
        }
        if (this.form.pI_Email === '') {
          this.form.pI_Email = info.userInfo.email;
        }
        this.submit();
      });
      if (
        this.userInfo.study !== undefined &&
        this.userInfo.study.form !== undefined
      ) {
        Object.assign(this.form, this.userInfo.study.form);
      }
      }
    degreeChange() {
      this.degreeOtherSelected =
        _.findIndex(this.form.degrees, (o: any) => o === -9) !== -1;
      setTimeout(() => {
        this.submit();
        this.loadDegrees();
      }, 10);
    }
    mounted() {
      this.loadToForm();
      this.validateForm();
      this.loadDegrees();
      this.$v.$reset(); // Added so form wouldn't be validated on load
    }
    loadToForm() {
      bus.$on('userInfo', (payload: any) => {
        Object.assign(this.form, payload.study.form);
      });
    }
      loadDegrees() {
          bus.$on('userInfo', (payload: any) => {
              Object.assign(this.form, payload.study.degreeList);
              this.form.degrees = this.userInfo.study.degreeList;
              this.form.degreeOther = this.userInfo.study.degreeOther;
              this.degreeOtherSelected = this.form.degrees.indexOf(-9) !== -1;
          });
      }
      public textMsgChanged(changed: any) {
          if (
              this.form.textMsg === true &&
              this.form.provider_ID !== null &&
              this.form.pI_Cell !== null
          ) {
              this.$emit('text-msg-changed', true);
          } else {
              this.$emit('text-msg-changed', false);
          }
          if (this.form.textMsg === false) {
              this.$emit('text-msg-changed', true);
          }
      }
  }
  